import React from 'react';
import { Checkbox } from '@grofers/dock-design-kit';
import { VERIFICATION_CHECKLIST_ITEMS } from '../constants';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import { Step3ChecklistItemToggledEvent } from '../../../../analytics/copilot/events';

/**
 * The "Verification Steps" checklist inside a complaint's verification
 * card. `checkedIds` is the set of currently-ticked item ids; toggling an
 * item reports the full next set back to the parent so it stays the
 * single source of truth for "is everything checked".
 */
const VerificationChecklist = ({
  items = VERIFICATION_CHECKLIST_ITEMS,
  checkedIds = new Set(),
  onChange = () => {},
  orderId = null,
  cartId = null,
  customerId = null,
}) => {
  const toggleItem = (itemId, isSelected) => {
    const next = new Set(checkedIds);
    if (isSelected) {
      next.add(itemId);
    } else {
      next.delete(itemId);
    }
    Step3ChecklistItemToggledEvent({
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: customerId,
      [MetricsForJumboEvent.feature_meta]: {
        item_id: itemId,
        checked: isSelected,
      },
    });
    onChange(next);
  };

  return (
    <div className='tw-flex tw-flex-col tw-gap-[12px] tw-w-full'>
      <p className='tw-text-[14px] tw-leading-[18px] tw-font-medium tw-text-grey-800 tw-m-0'>
        Verification Steps
      </p>
      <div className='tw-flex tw-flex-col tw-gap-5 tw-w-full'>
        {items.map((item) => (
          <div
            key={item.id}
            className='tw-flex tw-gap-4 tw-items-start tw-w-full'
          >
            <div className='tw-flex tw-items-center tw-py-[2px] tw-mt-1'>
              <Checkbox
                size='sm'
                isSelected={checkedIds.has(item.id)}
                onChange={(isSelected) => toggleItem(item.id, isSelected)}
              />
            </div>
            <p className='tw-flex-1 tw-min-w-0 tw-text-[13px] tw-leading-snug tw-text-grey-800 tw-font-regular tw-m-0'>
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VerificationChecklist;
